<template>
  <div>
    <el-dialog
      :visible.sync="selfShow"
      :width="selfBillId ? '1640px' : '1568px'"
      :title="popupTitle.str"
      :close-on-click-modal="false"
      append-to-body
      @close="popupCancel"
    >
      <div v-if="isLoad" class="page-main">
        <div class="page-l" v-if="selfBillId">
          <DetailNav :module.sync="module" :id="selfBillId" />
        </div>
        <div class="page-r">
          <keep-alive>
            <component
              :is="`Cont${module}`"
              :isShowTiaoKuan="isShowTiaoKuan"
              :id.sync="selfBillId"
              :popupTitle="popupTitle"
              :isChuangJian="isChuangJian"
              :isFuZe="isFuZe"
              @success="popupCancel"
              @jump="jumpModule"
            />
          </keep-alive>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    DetailNav: () => import('./detail-nav'),
    ContVerify: () => import('./cont-verify'),
    ContQuote: () => import('./cont-quote'),
    ContContract: () => import('./cont-contract')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isSourceHeTong: {
      type: Boolean,
      defualt: false
    },
    billId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isLoad: false,
      selfShow: false,
      selfBillId: '',
      module: '',
      bill_code: '',
      status_str: '',
      isChuangJian: false,
      isFuZe: false
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    accountId() {
      return this.$store.state.loginAccount.id
    },
    popupTitle() {
      let result = {
        type: '',
        str: ''
      }
      let type = ''
      let code = this.bill_code
      let status = this.status_str
      if (this.isSourceHeTong) {
        type = '订单'
      } else {
        if (status) {
          if (status === '暂存' || status === '已驳回') {
            type = '核算单'
          } else {
            type = '订单'
          }
        } else {
          type = '核算单'
        }
      }
      result.type = type
      result.str = status ? `${type}(${code})-${status}` : type
      return result
    },
    // 是否显示合同条款
    isShowTiaoKuan() {
      return this.isSourceHeTong && !this.billId
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    selfBillId() {
      this.getDetailData()
    }
  },
  mounted() {
    this.isLoad = false
    this.selfShow = this.show
    this.module = this.isSourceHeTong && !!this.billId ? 'Contract' : 'Verify'
    if (this.billId) {
      this.selfBillId = this.billId
    } else {
      this.isChuangJian = true
      this.isLoad = true
    }
  },
  methods: {
    jumpModule(val) {
      this.module = val
    },
    // 获取-详情数据
    getDetailData() {
      this.isLoad = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/detail',
        params: {
          id: this.selfBillId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.bill_code = result.formData.bill_code
          this.status_str = result.formData.status_str
          this.isChuangJian = this.isAdmin || result.formData.saler_id === this.accountId
          this.isFuZe = this.isAdmin || result.formData.fu_ze_ren_id === this.accountId
          this.isLoad = true
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('success')
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  position: relative;
  display: flex;
  flex: 1;
  .page-l {
    margin-right: 10px;
  }
  .page-r {
    flex: 1;
  }
}
</style>
